
<nav class="navbar navbar-light bg-body-tertiary overall-site-layout">
	<div class="container-fluid">


    <a class="navbar-brand" [routerLink]='["/"]' (click)="isMenuCollapsed = true">
      <img src="../../assets/images/VerlanglijstOnlineLogo.svg"
        alt="Verlanglijst.online: Verlanglijstje maken en delen anno nu!">
    </a>

    <div class="ms-auto" *ngIf="!wishlistView || loggedIn ">
      <ng-container *ngIf="!loggedIn && isBrowser">
        <button type="button" class="btn btn-secondary btn-big shadow show-on-desktop" (click)="isMenuCollapsed = true"
          routerLink="/auth/inloggen">
          Inloggen
        </button>
        <button type="button" class="btn btn-primary btn-big shadow ms-3 show-on-desktop" (click)="isMenuCollapsed = true"
          routerLink="/auth/aanmelden">
          Nu starten
        </button>
      </ng-container>

      <button class="btnTransparent navbar-toggler mt-2 ms-3 me-1 show-on-mobile" type="button" aria-label="navigatie"
      (click)="isMenuCollapsed = !isMenuCollapsed">
      <svg height="25" width="25">
        <g fill="none">
          <path stroke="#FFFFFF" stroke-width="3" d="M0 4 l215 0" />
          <path stroke="#FFFFFF" stroke-width="3" d="M0 13 l215 0" />
          <path stroke="#FFFFFF" stroke-width="3" d="M0 22 l215 0" />
        </g>
      </svg>
      </button>

      <button class="btnWhite navbar-toggler shadow show-on-desktop ms-3" type="button" aria-label="navigatie"
      (click)="isMenuCollapsed = !isMenuCollapsed">
      <svg height="30" width="30">
        <g fill="none">
          <path stroke="#1F305E" stroke-width="2" d="M0 8 l215 0" />
          <path stroke="#17a2b8" stroke-width="2" d="M0 16 l215 0" />
          <path stroke="#02b3b7" stroke-width="2" d="M0 24 l215 0" />
        </g>
        Menu
      </svg>
      </button>
      


    </div>
    


		<div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">

      <ng-container *ngIf="!loggedIn" class="ms-4 mt-4 me-4">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a routerLink="." 
               routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Verlanglijstje maken</a>
          </li>

          <li class="nav-item">
            <a routerLink="/lootjestrekken" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Lootjes trekken</a>
          </li>
          <li class="nav-item">
            <a routerLink="/catalogus" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Zoek in Cadeauzoeker</a>
          </li>
          <li class="nav-item">
            <a routerLink="/help" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Help</a>
          </li>
        </ul>
        <button type="button" class="btn btn-primary btn-big shadow show-on-mobile" routerLink="/auth/aanmelden"
        (click)="isMenuCollapsed = true">
          Nu starten
        </button>
        <br>
        <button type="button" class=" btn btn-secondary btn-big shadow  mt-2 show-on-mobile" routerLink="/auth/inloggen"
        (click)="isMenuCollapsed = true">
          Inloggen
        </button>

      </ng-container>

      <ng-container *ngIf="loggedIn">
        <ul class="navbar-nav">
          <li class="nav-item mt-4">
            <a [routerLink]="['/mijnlijstjes']" 
               [queryParams]="{view: 'all'}"
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Mijn Lijstjes & Lootjes</a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/mijnlijstjes']" 
               [queryParams]="{view: 'add'}"
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Nieuw verlanglijstje</a>
          </li>
          <li class="nav-item">
            <a routerLink="/lootjestrekken" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Lootjes trekken</a>
          </li>
          <li class="nav-item">
            <a routerLink="/catalogus" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Zoek in Cadeauzoeker</a>
          </li>
          <li class="nav-item">
            <a routerLink="/afgestreept/doormij" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Dit heb ik afgestreept</a>
          </li>
          <li class="nav-item">
            <a routerLink="/help" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Help</a>
          </li>
          <li class="nav-item">
            <a routerLink="/account" 
               routerLinkActive="active"
               class="nav-link" 
               (click)="isMenuCollapsed = true">Mijn account</a>
          </li>
          <li class="nav-item">
            <a routerLink="." 
               class="nav-link" 
               (click)="logout(); isMenuCollapsed = true">Uitloggen</a>
          </li>
        </ul>

      </ng-container>


		</div>


	</div>
</nav>



